import { SectionField } from "types/Models/Filing";

export const isHiddenForRole = (
  field: Pick<SectionField, "is_hidden_for_customer" | "is_hidden_for_admin">,
  isCustomer: boolean
): boolean =>
  Boolean(
    (field.is_hidden_for_customer && isCustomer) ||
      (field.is_hidden_for_admin && !isCustomer)
  );
